var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('br'),_c('center',[_c('span',[_c('strong',[_vm._v(" "+_vm._s(_vm.$t("access.denied")))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }